export default __webpack_public_path__ + "static/media/angry.5bd8c7f7.svg";